import { createSlice } from "@reduxjs/toolkit";
import {
  getCampaignsForPurchase,
  updateStripeCardPayments,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";
const initialState = {
  isLoading: false,
  isPaymentLoading: false,
  Status: "idle",
  StatusMsg: null,
  error: null,
  user: null,
  purchaseCampaign: [],
};
export const CampaignPurchaseSlice = createSlice({
  name: "campaignpurchase",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get campaign to purchase
    builder
      .addCase(getCampaignsForPurchase.pending, (state) => {
        state.isLoading = true;
        state.Status = "loading";
        state.error = null;
        state.StatusMsg = null;
      })
      .addCase(getCampaignsForPurchase.fulfilled, (state, action) => {
        state.isLoading = false;
        state.Status = "success";
        state.purchaseCampaign = action.payload?.campaigns || [];
        state.totalPriceDetails = action.payload?.total_price_details || {};
        state.termsDetails = action.payload?.terms_details ?? {};
        state.error = null;
      })
      .addCase(getCampaignsForPurchase.rejected, (state, action) => {
        state.isLoading = false;
        state.Status = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    //payments to purchase campaigns
    builder
      .addCase(updateStripeCardPayments.pending, (state) => {
        state.isPaymentLoading = true;
        state.Status = "loading";
        state.error = null;
        state.StatusMsg = null;
      })
      .addCase(updateStripeCardPayments.fulfilled, (state, action) => {
        state.isPaymentLoading = false;
        state.Status = "success";
        state.error = null;
      })
      .addCase(updateStripeCardPayments.rejected, (state, action) => {
        state.isPaymentLoading = false;
        state.Status = "failed";
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});
export default CampaignPurchaseSlice.reducer;
